import { render, staticRenderFns } from "./FormHotel.vue?vue&type=template&id=18be9fe4&"
import script from "./FormHotel.vue?vue&type=script&lang=js&"
export * from "./FormHotel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18be9fe4')) {
      api.createRecord('18be9fe4', component.options)
    } else {
      api.reload('18be9fe4', component.options)
    }
    module.hot.accept("./FormHotel.vue?vue&type=template&id=18be9fe4&", function () {
      api.rerender('18be9fe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hotel/form/FormHotel.vue"
export default component.exports